import mainAPI from '../mainAPI';

export const getAllAdvisors = {
    getAdvisors: params => {
      return mainAPI.get(`/api/advisors/GetAllAdvisor`, params);
    }
 };
